import React, {useState, useEffect} from 'react';
import Link from "next/link";
import {UserContext} from "@providers/user";
import styled from "styled-components";
import Login from "@molecules/auth/login";
import NavBarItems from "./components/items";
import NavBarAccount from "./components/account";
import NavBarDrawer from "./components/drawer";
import PropertyCreateButton from "./components/property.create.button";
import ConvertPixelToRem from "@helpers/convert.rem";
import ButtonTransparent from "@atoms/button.transparent";
import {isEmpty, str_replace} from '../../helpers/helpers';
import BadeSabaNavbar from "../../molecules/bade_saba/navbar";
import {handleBrandUrl, handleNavbarLinks} from "./helpers";
import BrandIcon from '@icons/2nabsh-logo.svg';
import {getDefaultCity} from "../../hooks/cities";

function Navbar({investmentEventSection, investmentEventView, navbarLinks, isBadeSaba, fluid, fixed, className, setShowLoginModal, showLoginModal, loginCallback, selectedCityId}) {
    const userContext = React.useContext(UserContext);

    const [navbarToggle, setNavbarToggle] = useState(false);
    const [loginShow, setLoginShow] = useState(false);
    const [forceShowBtnCreate, setForceShowBtnCreate] = useState(false);
    const [navbarLinksState, setNavbarLinksState] = useState({
        city_id: '',
        isNorthCity: false,
        navSaleLinks: [],
        navRentLinks: [],
        defaultCity: null,
        saleLink: [],
        rentLink: []
    });

    const navbarItemsLinks = (!isEmpty(navbarLinksState) && !isEmpty(navbarLinksState.defaultCity)) ? navbarLinksState : (!isEmpty(navbarLinks) ? navbarLinks : navbarLinksState);
    let defaultCity;
    if (navbarItemsLinks) {
        defaultCity = navbarItemsLinks.defaultCity;
    }

    useEffect(() => {
        const city_id = !isEmpty(selectedCityId) ? selectedCityId : getDefaultCity();

        if (isEmpty(navbarLinks) || (Number(navbarLinks['city_id']) !== Number(city_id))) {
            if (!isEmpty(navbarLinks)) {
                navbarLinks['city_id'] = '';
            }

            handleNavbarLinks(city_id).then(result => {
                setNavbarLinksState(result)
            })
        }
    }, [selectedCityId, navbarLinks]);

    useEffect(() => {
        setLoginShow(showLoginModal)
    }, [showLoginModal]);

    const handleLoginShow = (val) => {
        setLoginShow(val);
        if (!isEmpty(setShowLoginModal)) {
            setShowLoginModal(false)
        }
    };

    const hamburgerMenuClickHandler = (e) => {
        if (window.history.state === 'back') {
            window.history.pushState(null, null, null);
        }
        setNavbarToggle(true);
    };

    if (isBadeSaba) {
        return <BadeSabaNavbar fixed={fixed} fluid={fluid} className={className}/>
    } else {
        return (
            <Container className={(fixed ? 'fixed-navbar ' : '') + (className ? className : '')}>
                <div className={fluid ? 'container-fluid' : 'container'}>
                    <Card className="navbar-card">
                        <Header>
                            <ButtonTransparent onClick={(e) => hamburgerMenuClickHandler(e)} className="d-lg-none p-0">
                                <img src="/_img/icons/hamburger.svg" width="20" className="icon-bar" alt="hamburger.svg"/>
                            </ButtonTransparent>

                            <Brand>
                                <Link href={(!isEmpty(defaultCity) ? '/properties' : '/')} as={handleBrandUrl(defaultCity)}>
                                    <a title="۲نبش">
                                        <BrandIcon/>
                                    </a>
                                </Link>
                            </Brand>

                            <div className={((userContext.check && userContext.isContact && !forceShowBtnCreate) ? 'd-none ' : 'd-lg-none')}>
                                <BtnCreateProperty href="/ثبت/ملک" hrefAs="" id="js-mobile-navbar-create-property">
                                    ثبت آگهی رایگان
                                </BtnCreateProperty>
                            </div>

                        </Header>

                        <NavBarItems
                            isBadeSaba={isBadeSaba}
                            investmentEventSection={investmentEventSection}
                            investmentEventView={investmentEventView}
                            navbarItemsLinks={navbarItemsLinks}
                            setNavbarToggle={setNavbarToggle}
                            className="d-none d-lg-flex"/>

                        <NavBarAccount
                            setLoginShow={handleLoginShow}
                            setForceShowBtnCreate={setForceShowBtnCreate}
                            className="d-none d-lg-block"/>

                        <PropertyCreateButton id="btnRegister" className={((userContext.check && userContext.isContact && !forceShowBtnCreate) ? 'd-none ' : 'd-none d-lg-block')}/>

                        <NavBarDrawer
                            isBadeSaba={isBadeSaba}
                            investmentEventSection={investmentEventSection}
                            investmentEventView={investmentEventView}
                            navbarItemsLinks={navbarItemsLinks}
                            show={navbarToggle}
                            setNavbarToggle={setNavbarToggle}
                            setLoginShow={handleLoginShow}/>

                    </Card>
                </div>

                <Login show={loginShow} setShow={handleLoginShow} setForceShowBtnCreate={setForceShowBtnCreate} callback={loginCallback}/>
            </Container>
        )
    }
}

export default React.memo(Navbar);
// styles

const Container = styled.div`
    background-color: ${props => props.theme.white};
    border-bottom:1px solid ${props => props.theme.gray200};
    position: static;
    top: 0;
    right: 0;
    left: 0;
    z-index: 5001;
    
    &.fixed-navbar {
        position: fixed;
    }
    
    &.properties-search-navbar {
        transition: all .2s ease;
    }
    
    .modal-open & {
        z-index: 50 !important;
    }
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        border-bottom: 0;
    }
    
    &.bg-transparent {
        border: 0;
    }
    
    &.prices-navbar-container {
        background-color: ${props => props.theme.gray100};
        border: none;
    }
`;

const Card = styled.div`
    display: flex;
    align-items: center;
    height: 79px;
    //background-color: ${props => props.theme.white};
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        height: 56px;
    }
`;

const Brand = styled.div`
  line-height: 0;
`;

const Header = styled.div`
    @media (max-width: ${props => props.theme.screenSmMax}) {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        ${Brand} {
            position: absolute;
            right: 0;
            left: 0;
            width: 80px!important;
            margin: 0 auto!important;
        }
    }
`;

const BtnCreateProperty = styled.a`
    float: none !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: transparent !important;
    margin: 0;
    color: ${props => props.theme.black} !important;
    border: 0;
    line-height: 1.4 !important;
    border-radius: 0;
    font-size: ${ConvertPixelToRem(14)};
    font-weight: 500;
    border-bottom:1px solid ${props => props.theme.black} !important;
`;